import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import RemoveIcon from 'assets/images/icons/remove.svg';

import styles from './styles.module.less';

const checkHasChildren = children =>
  !(
    children === null ||
    children === undefined ||
    (Array.isArray(children) && children.length === 0)
  );

const SideDrawerHeader = ({ header, handleClose, clearBtn }) => {
  // If a custom header is passed in, render it inside the sideDrawerHeaderContainer
  if (typeof header !== 'string') {
    return <div className={styles.sideDrawerHeaderContainer}>{header}</div>;
  }

  // Otherwise, just render the standard header
  return (
    <div className={cx(styles.sideDrawerHeaderContainer, styles.standard)}>
      {clearBtn}
      <div className={styles.drawerHeader}>{header}</div>
      <ButtonV3 className={styles.closeBtn} variant="secondary" onClick={handleClose}>
        <img src={RemoveIcon} width="20" height="20" alt="close" />
      </ButtonV3>
    </div>
  );
};

class ProvisionalSideDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawerClosing: false,
    };

    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    const { onClose } = this.props;
    this.setState({
      drawerClosing: true,
    });
    onClose();
  }

  render() {
    const { header, children, displayDrawer, clearBtn } = this.props;
    const { drawerClosing } = this.state;
    const hasChildren = checkHasChildren(children);

    return (
      <div className={styles.tempSideDrawer}>
        <div className={styles.sideDrawerContainer}>
          <div
            className={cx({ [styles.sideDrawerBackgroundOverlay]: displayDrawer })}
            onClick={this.handleClose}
          />
          <div
            className={cx(
              styles.sideDrawerBody,
              { [styles.sideDrawerClosing]: !displayDrawer && drawerClosing },
              { [styles.sideDrawerOpening]: displayDrawer }
            )}
          >
            <SideDrawerHeader handleClose={this.handleClose} header={header} clearBtn={clearBtn} />
            <div className={styles.sideDrawerContent}>{hasChildren && children}</div>
          </div>
        </div>
      </div>
    );
  }
}

ProvisionalSideDrawer.propTypes = {
  children: PropTypes.node,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  displayDrawer: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ProvisionalSideDrawer;
